import React from "react";
import { useFetchData, useParseRouteActions } from "../../../helpers/GlobalHelper";
import LmsTable from "../ui/LmsTable";
import { AddProformaForm } from "../ui/LmsSharedForms";
import LmsFormGenerator, { BCFormController } from "../ui/LmsFormGenerator";
import LmsTabPages from "../ui/LmsTabPages";
import { FeatureFlags } from "../../constants/LocalServerConstants";

const LoanDataCashFlowTable = () => {
  return <LmsTable
    actionButtons={["add", "remove", "export"]}
    apiSuffix="document/loan-data-cash-flows"
    deleteSuffix="document/loan-data-cash-flow-upload"
    columnClickOptions={{
      attachmentFileName: {
        path: "/documents-upload-loan-data-cash-flow/{id}",
        idProp: "id",
      },
    }}
  />;
};

export const ViewLoanDataCashFlow = ({ dataUploadId }) => {
  const [{ data, isLoading, error }] = useFetchData(`document/loan-data-cash-flow/${dataUploadId}`);      
  const description =  data?.description?.split(".");
  const myForm = new BCFormController(data, { skipPlaceHolder: true, values: { description: description } });
  // TODO: check Sprint Work 14932 to continue
  myForm.addCenteredGroup([myForm.getDisplayField("Loan", { name:"loanApplicationNumberDisplay" })]);
  myForm.addCenteredGroup([myForm.getLinkField("Attachment", { linkType: "DownloadFile", name: "attachmentFileName", link: `budget/uploads/${dataUploadId}/export`, method: "POST" })]),
  myForm.addCenteredGroup([myForm.getLabelField("Result")]);
  myForm.addCenteredGroup([myForm.getListField("description", { listOptions:[], listItemType: "Text" })], { groupClassName: "lms-form-input-label-warning-text" });
  myForm.addCenteredGroup([myForm.getDisplayField("Created By")]);
  myForm.addCenteredGroup([myForm.getDisplayField("Created On", { value: new Date(data?.createdOn).toLocaleString() })]);

  const handleSubmit = (data) => {
    if (FeatureFlags.IS_DEBUG) {
      console.log(data);
    }
  };

  const tabPages = {
    Details: <LmsTable actionButtons={["export"]} skipClick apiSuffix={`document/loan-data-cash-flows/${dataUploadId}`} sortable={["Created On"]} columnLabelsDictionary={{ lmstab: "LMS Tab" }} />
  } ;

  return <React.Fragment>
    <LmsFormGenerator myForm={myForm} isLoading={isLoading} error={error} handleSubmit={handleSubmit} actions={["close"]}/>
    <LmsTabPages tabPages={tabPages}/>
  </React.Fragment>;
};

const LmsUploadLoanDataCashFlow = ({ ...props }) => {
  const { params = {}, history } = props;
  const allowedActions = ["add"];
  const allowedSubpages = [];
  const { isAdd, isEdit, isMainPage, id, isActionAllowed } = useParseRouteActions(params, allowedActions, allowedSubpages);

  if (!isActionAllowed) {
    history.goBack();
  }

  return <React.Fragment>
    {isMainPage && <LoanDataCashFlowTable />}
    {isAdd && <AddProformaForm />}
    {isEdit && <ViewLoanDataCashFlow dataUploadId={id} />}
  </React.Fragment>;
};

export default LmsUploadLoanDataCashFlow;